import Image from '@atlaskit/image';
import topNavItemsAnatomyLight from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-anatomy-light.png";
import topNavItemsAnatomyDark from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-anatomy-dark.png";
import topNavItemsDo1Light from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-do-1-light.png";
import topNavItemsDo1Dark from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-do-1-dark.png";
import topNavItemsDo2Light from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-do-2-light.png";
import topNavItemsDo2Dark from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-do-2-dark.png";
import topNavItemsDont1Light from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-dont-1-light.png";
import topNavItemsDont1Dark from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-dont-1-dark.png";
import topNavItemsDont2Light from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-dont-2-light.png";
import topNavItemsDont2Dark from "../../../../../../packages/design-system/navigation-system/constellation/top-nav-items/images/topNavItems-dont-2-dark.png";
import * as React from 'react';
export default {
  Image,
  topNavItemsAnatomyLight,
  topNavItemsAnatomyDark,
  topNavItemsDo1Light,
  topNavItemsDo1Dark,
  topNavItemsDo2Light,
  topNavItemsDo2Dark,
  topNavItemsDont1Light,
  topNavItemsDont1Dark,
  topNavItemsDont2Light,
  topNavItemsDont2Dark,
  React
};